import React, { Component, forwardRef } from "react"
import Svg from "../_svgs/svg"
import * as dateHelper from "../../booking/helpers/date"
import { DateTime } from "luxon"
import * as SelectionFactoryHelper from "../helpers/SelectionFactoryHelper"
import * as endpoint from "../../booking/constants/Endpoints"
import DatePicker, { CalendarContainer } from "react-datepicker"
import da from "date-fns/locale/da"
import enGB from "date-fns/locale/en-GB"
import { isMobile } from "react-device-detect"
import axios from "axios"
import Spinner from "../../booking/components/spinner"
import GenericModal from "../../booking/components/common/genericModal"
import * as cookieHelper from "../../helpers/cookie"
import * as cookieNames from "../../booking/constants/Cookies"
import SimpleModal from "../../shared/modal/simple-modal"
import RefundGuarantee from "../../booking/components/ParkingList/refundGuarantee"
import ParkingProductHightlight from "../../booking/components/ParkingList/parkingProductHighlight"
import ParkingDetailsModal from "../../booking/components/ParkingList/parkingDetailsModal"
import ParkingShowMapModal from "../../booking/components/ParkingList/parkingShowMapModal"
import ParkingAcceptConditionsModal from "../../booking/components/ParkingList/parkingAcceptConditionsModal"
import ParkingBuyMemberProductModal from "../../booking/components/ParkingList/parkingBuyMemberProductModal"
import config from "react-global-configuration"
import { trackTravelPlannerParkingSearch, trackTravelPlannerInteraction } from "../../helpers/tracking"
import { getQueryStringValue, setQueryStringValue } from "../../api/queryStringHelper"

export class ItineraryArrivalAtAirport extends Component {
  constructor(props) {
    super(props)

    this.state = {
      block: props.block,
      flightInfo: props.flightInfo,
      airlinesPageLink: props.airlinesPageLink,
      hidePastSteps: props.hidePastSteps,
      profile: props.profile,
      isLoggedIn: props.isLoggedIn,
      travelInformation: props.travelInformation,
      travelFormBlock: undefined,
      parkingConfig: undefined,
      parkingContent: undefined,
      language: props.flightInfo.language,
      ajaxSpinnerActive: false,
      ajaxSpinnerTransparent: false,
      parkingHighlights: undefined,
      refundGuaranteeModalOpen: false,
      refundGuaranteeModalData: undefined,
      userAccountDetails: undefined,
      isLoaded: false,
      sectionOpen: false,
      showBookingStarter: false,
      accordionOpen: false,
    }

    if (props.block.showParkingStarter) {
      const queryAdt = getQueryStringValue("adt")
      const queryDdt = getQueryStringValue("ddt")

      const dtLocale = dateHelper.luxonLocale(props.flightInfo.language)
      const zone = "Europe/Copenhagen"
      const flightTime = DateTime.fromISO(props.flightInfo.EstimatedPublicTime).setLocale(dtLocale).setZone(zone)
      const cphFlightTime = flightTime.setZone("local", { keepLocalTime: true })

      const currentTime = DateTime.local().setLocale(dtLocale).setZone(zone)
      const cphTime = currentTime.setZone("local", { keepLocalTime: true })

      const leadTimeDate = dateHelper.RoundDownToNearestMinutesLuxon(cphFlightTime, 30).minus({ minutes: props.block.leadTimeMinutes })
      const absoluteMinDateTime = dateHelper
        .RoundToNearestMinutesLuxon(cphTime, 30)
        .plus({ minutes: props.block.leadTimeMinutes })
        .set({ seconds: 0, milliseconds: 0 })

      this.adtCalender = React.createRef()
      this.ddtCalender = React.createRef()

      const today = cphTime
      const maxTime = cphTime.set({ hours: 23, minutes: 30, seconds: 0, milliseconds: 0 })
      const minTime = cphTime.set({ hours: 0, minutes: 30, seconds: 0, milliseconds: 0 })

      this.state.today = today
      this.state.aMinTime = minTime
      this.state.dMinTime = minTime
      this.state.maxTime = maxTime
      this.state.minDate = today
      this.state.absoluteMinDateTime = absoluteMinDateTime

      if (queryAdt && queryDdt) {
        this.state.adt = DateTime.fromISO(queryAdt)
        this.state.ddt = DateTime.fromISO(queryDdt)
        this.state.showBookingStarter = true
      } else if (cphTime < leadTimeDate) {
        let arrivalDate = dateHelper.RoundDownToNearestMinutesLuxon(cphFlightTime, 30).minus({ minutes: props.block.minutesBeforeParking })
        if (cphTime >= arrivalDate) {
          arrivalDate = dateHelper.RoundToNearestMinutesLuxon(cphTime, 30).plus({ minutes: props.block.leadTimeMinutes })
        }

        const departureDate = cphFlightTime.plus({ days: 7 }).set({ hours: 17, minutes: 30, seconds: 0, milliseconds: 0 })

        this.state.adt = arrivalDate
        this.state.ddt = departureDate
        this.state.showBookingStarter = true
      }
    }

    this.renderContentBlocks = this.props.renderContentBlocks.bind(this)
    this.showHideContent = this.props.showHideContent.bind(this)
    this.handleClickTracking = this.props.handleClickTracking.bind(this)
  }

  async componentDidMount() {
    if (this.state.profile && this.state.profile !== {}) {
      this.setState({ isLoggedIn: true }, () => {
        this.getTravelFormContent()
      })
    }
    if (this.state.showBookingStarter) {
      this.setLoginState()
      const newState = {}

      // get parking content
      const lang = this.state.language
      const data = { language: lang }
      const returns = await Promise.all([this.getParkingContent(data), this.getParkingConfig(data)])
        .then((responses) => {
          return Promise.all(
            responses.map((response) => {
              return response
            }),
          )
        })
        .then((data) => {
          return data
        })
        .catch((err) => {
          console.log(err)
        })
      const parkingContent = returns[0]
      const parkingConfig = returns[1]
      newState["parkingContent"] = parkingContent
      newState["parkingConfig"] = parkingConfig
      config.set(parkingConfig)

      // handle datepicker config if flightdate is today
      const dtLocale = dateHelper.luxonLocale(lang)
      const zone = "Europe/Copenhagen"
      const currentTime = DateTime.local().setLocale(dtLocale).setZone(zone)
      const cphTime = currentTime.setZone("local", { keepLocalTime: true })

      if (this.state.adt) {
        const isToday = this.state.today.startOf("day").toMillis() === this.state.adt.startOf("day").toMillis()
        const mintime = cphTime.plus({ hours: 1 })
        if (isToday) {
          newState["aMinTime"] = mintime
        }
      }

      if (this.state.ddt) {
        const isToday = this.state.today.startOf("day").toMillis() === this.state.ddt.startOf("day").toMillis()
        const mintime = cphTime.plus({ hours: 3 })
        if (isToday) {
          newState["dMinTime"] = mintime
          newState["minDate"] = mintime
        }
      }

      this.setState({ ...newState }, () => {
        const queryAdt = getQueryStringValue("adt")
        const queryDdt = getQueryStringValue("ddt")
        if (queryAdt && queryDdt) {
          this.parkingSearchHandler()
        }
      })

      window.addEventListener("resize", () => {
        if (this.state.sectionOpen) {
          this.handleAccordionResize()
        }
      })
      window.addEventListener("load", () => {
        const image = document.querySelector(".refund-image")
        if (image) {
          const isLoaded = image.complete && image.naturalHeight !== 0
          if (isLoaded) {
            this.handleAccordionResize()
            const parkingStarter = document.getElementsByClassName("parking-result")[0]
            if (parkingStarter) {
              this.scrollIntoView(parkingStarter)
            }
          }
        }
      })
    }
  }

  componentDidUpdate() {
    if (this.state.profile !== this.props.profile) {
      this.setState({ profile: this.props.profile })
    }
    if (this.state.travelInformation !== this.props.travelInformation) {
      this.setState({ travelInformation: this.props.travelInformation }, () => {
        this.getTravelFormContent()
      })
    }
    if (this.state.showBookingStarter && this.state.isLoaded) {
      this.setState({ isLoaded: false }, () => {
        requestAnimationFrame(() => {
          // figure out a way to not use timeout
          setTimeout(() => {
            this.handleAccordionResize()
          }, 300)
        })
      })
    }
  }

  scrollIntoView = (element) => {
    const followFlight = document.getElementsByClassName("follow-flight__wrapper")[0]
    const headerOffset = followFlight.clientHeight + 20
    const elementPosition = element.getBoundingClientRect().top
    const offsetPosition = elementPosition + window.pageYOffset - headerOffset

    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth",
    })
  }

  getTravelFormContent() {
    if (this.props.travelInformation && this.props.travelInformation.length > 0) {
      for (let i = 0; i < this.props.travelInformation.length; i++) {
        const element = this.props.travelInformation[i]
        if (element.Registration_Source__c === "Travel Guide") {
          switch (element.Transportation_to_Airport__c) {
            case "Bus":
              this.setState({ travelFormBlock: this.props.block.travelFormBus })
              break
            case "Driven by another":
              this.setState({ travelFormBlock: this.props.block.travelFormDriven })
              break
            case "Private car (or motorcycle, scooter)":
              this.setState({ travelFormBlock: this.props.block.travelFormOwnVehicle })
              break
            case "Flight (transit)":
              this.setState({ travelFormBlock: this.props.block.travelFormFlight })
              break
            case "Metro":
              this.setState({ travelFormBlock: this.props.block.travelFormMetro })
              break
            case "Taxi":
              this.setState({ travelFormBlock: this.props.block.travelFormTaxi })
              break
            case "Train":
              this.setState({ travelFormBlock: this.props.block.travelFormTrain })
              break
            case "Other":
              this.setState({ travelFormBlock: this.props.block.travelFormOther })
              break
            case null || undefined:
              this.setState({ travelFormBlock: this.props.block.travelFormDontKnow })
              break
          }
          return
        }
      }
    }
  }

  getParkingContent = (data) => {
    const hosts = document.body.dataset.hosts && JSON.parse(document.body.dataset.hosts)
    return axios
      .get(endpoint.PARKING_CONTENT(data, hosts))
      .then((res) => {
        return res.data
      })
      .catch((err) => {
        console.log(err)
      })
  }

  getParkingConfig = (data) => {
    const hosts = document.body.dataset.hosts && JSON.parse(document.body.dataset.hosts)
    return axios
      .get(endpoint.PARKING_CONFIG(data, hosts))
      .then((res) => {
        return res.data
      })
      .catch((err) => {
        console.log(err)
      })
  }

  addEventListeners = () => {
    let dateselect = document.querySelector("#tp-parking")

    setTimeout(() => {
      if (dateselect) {
        const timeItems = dateselect.querySelectorAll(".react-datepicker__time-list-item")
        if (timeItems.length > 0) {
          timeItems.forEach((item) => {
            item.addEventListener("click", () => this.openDdtCalender())
          })
        }
      }
    }, 100)
  }

  handleFromDateChange = (dateInput) => {
    const dtLocale = dateHelper.luxonLocale(this.state.language)
    const zone = "Europe/Copenhagen"
    const currentTime = DateTime.local().setLocale(dtLocale).setZone(zone)
    const cphTime = currentTime.setZone("local", { keepLocalTime: true })

    const newFromDate = DateTime.fromJSDate(dateInput)
    const isToday = this.state.today.startOf("day").toMillis() === newFromDate.startOf("day").toMillis()
    const isSameDay = this.state.ddt.startOf("day").toMillis() === newFromDate.startOf("day").toMillis()
    const oldDate = this.state.adt

    if (isToday) {
      const roundedTime = dateHelper.RoundToNearestMinutesLuxon(cphTime.set({ seconds: 0 }), 30)
      const aMinTime = roundedTime.plus({ hours: 1 })
      const minDate = newFromDate.plus({ hours: 2 })
      if (newFromDate >= aMinTime) {
        this.setState({ adt: newFromDate, aMinTime: aMinTime, minDate: minDate })
      } else {
        this.setState({ adt: aMinTime, aMinTime: aMinTime, minDate: minDate })
      }
    } else {
      const aMinTime = newFromDate.set({ hours: 0, minutes: 30 })
      this.setState({ adt: newFromDate, aMinTime: aMinTime, minDate: newFromDate })
    }
    if (this.state.ddt <= dateInput) {
      const duration = this.state.ddt.diff(oldDate, ["days", "hours"]).toObject()
      const dayDifference = Math.floor(duration.days)
      let newEndDate = newFromDate.plus({ days: duration.days, hours: duration.hours })
      const newState = {
        adt: newFromDate,
        ddt: newEndDate,
      }
      if (dayDifference === 0) {
        if (this.state.absoluteMinDateTime.toMillis() === newFromDate.toMillis()) {
          newEndDate = newEndDate.plus({ hours: 2 })
        } else {
          newEndDate = newEndDate.plus({ hours: 1 })
        }
        newState["dMinTime"] = newEndDate
        newState["minDate"] = newEndDate
        newState["ddt"] = newEndDate
      }
      this.setState({
        ...newState,
      })
    } else if (isSameDay) {
      let mintime
      if (this.state.absoluteMinDateTime.toMillis() === newFromDate.toMillis()) {
        mintime = newFromDate.plus({ hours: 2 })
      } else {
        mintime = newFromDate.plus({ hours: 1 })
      }
      if (this.state.ddt >= mintime.plus({ hours: 1 })) {
        this.setState({ dMinTime: mintime })
      } else {
        this.setState({ dMinTime: mintime, ddt: mintime })
      }
    } else {
      const mintime = newFromDate.set({ hours: 0, minutes: 30, seconds: 0, milliseconds: 0 })
      this.setState({ dMinTime: mintime })
    }

    if (this.state.parkingHighlights) {
      this.parkingSearchHandler()
    }
    this.addEventListeners()
  }

  handleToDateChange = (dateInput) => {
    const newToDate = DateTime.fromJSDate(dateInput)
    const isToday = this.state.today.startOf("day").toMillis() === newToDate.startOf("day").toMillis()
    const isSameDay = this.state.adt.startOf("day").toMillis() === newToDate.startOf("day").toMillis()

    if (isToday) {
      let dMinTime
      if (this.state.absoluteMinDateTime.toMillis() === this.state.adt.set({ seconds: 0, milliseconds: 0 }).toMillis()) {
        dMinTime = this.state.adt.plus({ hours: 2 })
      } else {
        dMinTime = this.state.adt.plus({ hours: 1 })
      }
      if (newToDate >= dMinTime) {
        this.setState({ dMinTime: dMinTime, ddt: newToDate })
      } else {
        this.setState({ dMinTime: dMinTime, ddt: dMinTime })
      }
    } else if (isSameDay) {
      const minDateTime = this.state.adt.plus({ hours: 1 })
      if (newToDate > minDateTime) {
        this.setState({ dMinTime: minDateTime, ddt: newToDate })
      } else {
        this.setState({ dMinTime: minDateTime, ddt: minDateTime })
      }
    } else {
      const mintime = newToDate.set({ hours: 0, minutes: 30 })
      if (newToDate.hour === 0 && newToDate.minute === 0 && newToDate.second === 0) {
        this.setState({ ddt: mintime, dMinTime: mintime })
      } else {
        this.setState({ ddt: newToDate, dMinTime: mintime })
      }
    }

    if (this.state.parkingHighlights) {
      this.parkingSearchHandler()
    }
  }

  getHighlightDates = (startDate, endDate) => {
    if (!endDate) return [{ "react-datepicker__day--highlighted-start": [startDate.toJSDate()] }]
    const duration = endDate.diff(startDate, ["days"]).toObject()
    const dayDifference = Math.floor(duration.days)

    const highlightDates = [{ "react-datepicker__day--highlighted-start": [startDate.toJSDate()] }]
    const middleDates = []
    for (let i = 1; i < dayDifference + 1; i++) {
      middleDates.push(startDate.plus({ days: i }).toJSDate())
    }
    highlightDates.push({ "react-datepicker__day--highlighted": middleDates })
    highlightDates.push({ "react-datepicker__day--highlighted-end": [endDate.toJSDate()] })
    return highlightDates
  }

  openDdtCalender = () => {
    this.ddtCalender.setOpen(true)
  }

  handleAllParkingOptionsClick = () => {
    const arrival = this.state.adt.toFormat("yyyy-MM-dd")
    const departure = this.state.ddt.toFormat("yyyy-MM-dd")
    trackTravelPlannerParkingSearch("track-event", "show all parking options", "", this.state.flightInfo.FlightId, arrival, departure)
  }

  parkingSearchHandler = () => {
    const arrival = this.state.adt.toFormat("yyyy-MM-dd")
    const departure = this.state.ddt.toFormat("yyyy-MM-dd")
    trackTravelPlannerParkingSearch("track-event.generic", "arrival airport - price proposal", "", this.state.flightInfo.FlightId, arrival, departure)

    this.performParkingSearch()
  }

  performParkingSearch = () => {
    const textKeys = config.get("textKeys.dialog") || {}
    let terminalProximityPriority = ""
    let cheapestFacilityPriority = ""
    let bestOfferFacilityPriority = ""

    const arrival = this.state.adt.toFormat("yyyy-MM-dd HH:mm")
    const departure = this.state.ddt.toFormat("yyyy-MM-dd HH:mm")
    const arrivalDateTime = this.state.adt
    const departureDateTime = this.state.ddt

    setQueryStringValue("adt", arrivalDateTime.toISO())
    setQueryStringValue("ddt", departureDateTime.toISO())

    const duration = departureDateTime.diff(arrivalDateTime, ["days"]).toObject()
    const days = Math.floor(duration.days)

    const isLoggedIn = this.state.isLoggedIn
    const isShortDuration = days < 3

    // terminal proximity priority
    if (this.state.parkingContent.terminalProximityPriorityShortDuration && isShortDuration)
      if (this.state.parkingContent.terminalProximityPriorityShortDurationLoggedIn && isLoggedIn)
        terminalProximityPriority = this.state.parkingContent.terminalProximityPriorityShortDurationLoggedIn
      else terminalProximityPriority = this.state.parkingContent.terminalProximityPriorityShortDuration
    else if (this.state.parkingContent.terminalProximityPriority) terminalProximityPriority = this.state.parkingContent.terminalProximityPriority

    // cheapest facility priority
    if (this.state.parkingContent.cheapestFacilityPriorityShortDuration && isShortDuration)
      if (this.state.parkingContent.cheapestFacilityPriorityShortDurationLoggedIn && isLoggedIn)
        cheapestFacilityPriority = this.state.parkingContent.cheapestFacilityPriorityShortDurationLoggedIn
      else cheapestFacilityPriority = this.state.parkingContent.cheapestFacilityPriorityShortDuration
    else if (this.state.parkingContent.cheapestFacilityPriority) cheapestFacilityPriority = this.state.parkingContent.cheapestFacilityPriority

    // best offer priority
    if (this.state.parkingContent.bestOfferFacilityPriorityShortDuration && isShortDuration)
      if (this.state.parkingContent.bestOfferFacilityPriorityShortDurationLoggedIn && isLoggedIn)
        bestOfferFacilityPriority = this.state.parkingContent.bestOfferFacilityPriorityShortDurationLoggedIn
      else bestOfferFacilityPriority = this.state.parkingContent.bestOfferFacilityPriorityShortDuration
    else if (this.state.parkingContent.bestOfferFacilityPriority) bestOfferFacilityPriority = this.state.parkingContent.bestOfferFacilityPriority

    if (!this.state.loadingPerformParkingSearch) {
      this.setState(
        {
          ajaxSpinnerActive: true,
          loadingPerformParkingSearch: true,
          loadingPerformParkingSearchError: undefined,
        },
        () => {
          const hosts = document.body && document.body.dataset.hosts && JSON.parse(document.body.dataset.hosts)
          const url =
            endpoint.FIND_PARKING(hosts, this.state.language) +
            "?arrival=" +
            encodeURIComponent(arrival) +
            "&departure=" +
            encodeURIComponent(departure) +
            "&terminalProximityPriority=" +
            encodeURIComponent(terminalProximityPriority) +
            "&cheapestFacilityPriority=" +
            encodeURIComponent(cheapestFacilityPriority) +
            "&bestOfferFacilityPriority=" +
            encodeURIComponent(bestOfferFacilityPriority)
          axios
            .get(url)
            .then((res) => res.data)
            .then((searchResult) => {
              const result = searchResult.productCategories
              var allProducts = []
              if (result && result.length > 0) {
                result.forEach((element) => {
                  allProducts = [...allProducts, ...element.products]
                })
              }

              if (allProducts.length > 0) this.trackSoldOutRate(allProducts)

              this.setState({
                isLoaded: true,
                globals: searchResult.searchResultGlobals,
                durationDays: Math.ceil(Math.abs(this.state.ddt.toJSDate().getTime() - this.state.adt.toJSDate().getTime()) / (1000 * 60 * 60 * 24)),
                ajaxSpinnerActive: false,
                loadingPerformParkingSearch: false,
                parkingHighlights: searchResult.productHighlights,
                productCategories: result,
                allProducts,
              })
            })
            .catch((error) => {
              const text = this.axiosErrorHandler(
                error,
                {
                  ajaxSpinnerActive: false,
                  loadingPerformParkingSearch: false,
                  loadingPerformParkingSearchError: error,
                },
                {
                  badRequest: (_s) => {
                    this.genericModalOpen(
                      textKeys.noBookingInThePast ||
                        `<h3>Tidsfristen er overskredet</h3><p>Du kan tidligst booke 1 timer før ønsket ankomsttidspunkt</p>`,
                    )
                  },
                },
              )
              if (text) this.trackError(text.replace(/<\/?[^>]+(>|$)/g, " "), error, "search")
            })
        },
      )
    }
  }

  setZIndexOfDeck = (zindex) => {
    const tpDeck = document.querySelector(".deck--itinerary")
    if (tpDeck) {
      tpDeck.style.zIndex = zindex
    }
  }

  genericModalOpen = (html, callback) => {
    this.setState({
      genericModalActive: true,
      genericModalBody: html,
      genericModalCallback: callback,
    })
    this.setZIndexOfDeck(9900)
  }

  genericModalClose = (callback) => {
    this.setState(
      {
        genericModalActive: false,
        genericModalBody: undefined,
        genericModalCallback: undefined,
      },
      callback,
    )
    this.setZIndexOfDeck(null)
  }

  axiosErrorHandler = (error, errorState = {}, errorHandlers = {}) => {
    const textKeys = config.get("textKeys.dialog") || {}
    if (!error.response) {
      const text = textKeys.unknownError || `<h3>Fejl</h3><p>Der er sket en uventet fejl</p>`
      this.setState(errorState, errorHandlers.noResponse ? errorHandlers.noResponse(error.response.data) : this.genericModalOpen(text))
      return text
    }

    // parse by code
    if (error.response.status === 400) {
      const text =
        (textKeys.badRequestError && textKeys.badRequestError.replace("${", "{").replace("{message}", error.response.data.message)) ||
        `<h3>Fejl</h3><p>${error.response.data.message}</p>`

      this.setState(errorState, errorHandlers.badRequest ? errorHandlers.badRequest(error.response.data.message) : this.genericModalOpen(text))
      return text
    }

    /* old message string based error handling*/
    if (error.response.status === 404 || (error.response.data && error.response.data.message === "NotFound")) {
      const text = textKeys.notFoundError || `<h3>Fejl</h3><p>Der er en fejl i linket, hvis du har kopieret det ind så prøv igen</p>`
      this.setState(errorState, errorHandlers.notFound ? errorHandlers.notFound(error.response.data) : this.genericModalOpen(text))
      return text
    }

    if (error.response.status === 405 || (error.response.data && error.response.data.message === "MethodNotAllowed")) {
      const text =
        textKeys.sessionExpiredError ||
        `<h3>Fejl</h3><p>Din session er udløbet du har været inaktiv for længe, prøv at genindlæse siden ved at trykke på CTRL+R</p>`
      this.setState(errorState, errorHandlers.methodNotAllowed ? errorHandlers.methodNotAllowed(error.response.data) : this.genericModalOpen(text))
      return text
    }

    if (error.response && error.response.data.message && error.response.data.message) {
      const text =
        (textKeys.standardError && textKeys.standardError.replace("${", "{").replace("{message}", error.response.data.message)) ||
        `<h3>Fejl</h3><p>${error.response.data.message}</p>`
      this.genericModalOpen(text)
    }
    this.setState(errorState)
  }

  trackError = (text) => {
    const userId = cookieHelper.getUserId()

    const data = {
      event: "track-event",
      eventCategory: "travel planner",
      eventAction: "error",
      eventLabel: `search - ${text}`,
      eventValue: 0,
      eventNoninteraction: true,
      userParkingArrivalDate: this.state.adt.toFormat("yyyy-MM-dd"),
      userParkingDepartureDate: this.state.ddt.toFormat("yyyy-MM-dd"),
      logged_in: cookieHelper.isLoggedIn(),
    }
    if (userId) data.userId = userId
    window.dataLayer.push(data)
  }

  setDataToState = (data) => {
    this.setState(data)
  }

  handleModalOpen = (data) => {
    this.setDataToState(data)
    this.setZIndexOfDeck(9900)
  }

  handleModalClose = () => {
    this.setState({ refundGuaranteeModalOpen: false })
    this.setZIndexOfDeck(null)
  }

  handleAccordionResize = () => {
    const section = document.getElementById("arrival-at-airport")
    if (!section.classList.contains("open")) {
      section.__toggle = true
      section.classList.add("open")
    }

    const target = section.querySelector(".contentWrapper")
    const targetHeight = target.offsetHeight
    const innerTarget = target.querySelector(".innerContentWrapper")
    const innerTargetHeight = innerTarget.scrollHeight
    target.style.height = innerTargetHeight + "px"

    const inactiveSteps = document.getElementById("inactive-steps")
    if (inactiveSteps) {
      const parentHeight = inactiveSteps.offsetHeight
      const adjustedHeight = parentHeight - targetHeight + innerTargetHeight
      inactiveSteps.style.height = adjustedHeight + "px"
    }
    if (!this.state.sectionOpen) {
      this.setState({ sectionOpen: true })
    }
  }

  trackSoldOutRate = (allProducts) => {
    const { adt, ddt } = this.state
    const amountOfProducts = allProducts.length
    let amountOfSoldOutProducts = 0
    allProducts.forEach((item) => {
      if (item.product.isSoldOut) {
        amountOfSoldOutProducts++
      }
    })
    const userId = cookieHelper.getUserId()
    const data = {
      event: "track-event",
      eventCategory: "travel planner",
      eventAction: "sold out rate",
      eventLabel: `${amountOfSoldOutProducts}/${amountOfProducts}`,
      eventValue: parseFloat(amountOfSoldOutProducts / amountOfProducts).toFixed(2),
      eventNoninteraction: true,
      userParkingArrivalDate: adt.toFormat("yyyy-MM-dd"),
      userParkingDepartureDate: ddt.toFormat("yyyy-MM-dd"),
      travelplannerFlightId: this.state.flightInfo.FlightId,
      pageBusinessunit: "parking",
      logged_in: cookieHelper.isLoggedIn(),
    }
    if (userId) data.userId = userId
    window.dataLayer.push(data)
  }

  handleRefundGuaranteeModalTracking = () => {
    const arrival = this.state.adt.toFormat("yyyy-MM-dd")
    const departure = this.state.ddt.toFormat("yyyy-MM-dd")
    trackTravelPlannerParkingSearch("track-event", "free cancellation", "read more", this.state.flightInfo.FlightId, arrival, departure)
  }

  handleSpecialProductClickFromDetails = () => {
    this.setState({ isParkingDetailsModalActive: false, isParkingSpecialProductActive: true })
  }

  handleParkingDetailsClose = (callback) => {
    this.setState(
      {
        isParkingDetailsModalActive: false,
        isParkingHighlightModalActive: false,
      },
      callback,
    )

    this.setZIndexOfDeck(null)
  }

  handleParkingDetailsCleanup = () => {
    this.setState({
      parkingDetailsModalItem: undefined,
    })

    this.setZIndexOfDeck(null)
  }

  handleSpecialProductDetailsClose = (callback) => {
    this.setState(
      {
        isParkingSpecialProductActive: false,
      },
      callback,
    )

    this.setZIndexOfDeck(null)
  }

  handleSpecialProductDetailsCleanup = (callback) => {
    this.setState(
      {
        parkingDetailsModalItem: undefined,
      },
      callback,
    )

    this.setZIndexOfDeck(null)
  }

  handleBuyMemberProductModalClose = (callback) => {
    this.setState(
      {
        isParkingMemberProductActive: false,
      },
      callback,
    )

    this.setZIndexOfDeck(null)
  }

  handleBuyMemberProductCleanup = (callback) => {
    this.setState(
      {
        parkingDetailsModalItem: undefined,
      },
      callback,
    )

    this.setZIndexOfDeck(null)
  }

  handleCloseMapModal = () => {
    this.setState({ isParkingProductMapModalActive: false })
    this.setZIndexOfDeck(null)
  }

  handleOpenMapModal = () => {
    this.setState({
      isParkingProductMapModalActive: true,
      isParkingSpecialProductActive: false,
      isParkingDetailsModalActive: false,
    })

    this.setZIndexOfDeck(9900)
  }

  setLoginState = () => {
    const cookieToken = cookieHelper.getCookie(cookieNames.ACCESS_TOKEN)
    const currentToken = window.localStorage.myAuthToken
    if (!cookieToken) {
      if (currentToken) {
        // session timed out or logout was forced
        delete window.localStorage.myAuthToken
        delete axios.defaults.headers.common["Authorization"]
        this.setState({ userAccountDetails: undefined })
      }
    } else if (cookieToken !== currentToken || !this.state.userAccountDetails) {
      // new token arrived or state is not loaded
      window.localStorage.myAuthToken = cookieToken
      axios.defaults.headers.common["Authorization"] = "Bearer " + cookieToken
      this.loadUserAccountDetails()
    }
  }

  loadUserAccountDetails = () => {
    if (!this.state.loadingContactDetails) {
      this.setState({ loadingContactDetails: true, loadingContactDetailsError: undefined }, () => {
        const hosts = document.body && document.body.dataset.hosts && JSON.parse(document.body.dataset.hosts)
        axios
          .get(endpoint.ACCOUNT_DETAILS(hosts))
          .then((res) => res.data)
          .then((userAccountDetails) => {
            this.setState({
              userAccountDetails,
              loadingContactDetails: false,
              loadingContactDetailsError: undefined,
            })
          })
          .catch((error) => {
            console.log(error)
            this.axiosErrorHandler(error, {
              ajaxSpinnerActive: false,
              loadingContactDetails: false,
              loadingContactDetailsError: error,
            })
            // this is based on a mixup of uat and prod tokens, so remove the cookie to avoid loop
            cookieHelper.removeCookie(cookieNames.ACCESS_TOKEN)
          })
      })
    }
  }

  getSearchLink = () => {
    const searchLink = `${this.props.block.parkingPage}/search${this.getParkingLinkParams()}`
    return searchLink
  }

  getParkingLinkParams = () => {
    let { adt, ddt } = this.state
    if (!adt || !ddt) return null
    let ad = adt.toFormat("yyyy-MM-dd")
    let at = adt.toFormat("HH:mm")
    let dd = ddt.toFormat("yyyy-MM-dd")
    let dt = ddt.toFormat("HH:mm")
    return `?ad=${ad}&at=${at}&dd=${dd}&dt=${dt}`
  }

  getReserveLink = (guid, productId) => {
    return `${
      this.props.block.parkingPage
    }/search/extra-services${this.getParkingLinkParams()}&bguid=${guid}&parkingProductId=${productId}&flightId=${this.props.flightInfo.FlightId}`
  }

  handleReservation = (productId, item) => {
    const arrival = this.state.adt.toFormat("yyyy-MM-dd HH:mm")
    const departure = this.state.ddt.toFormat("yyyy-MM-dd HH:mm")
    const data = {
      arrivalDate: arrival,
      departureDate: departure,
      productId: productId,
      usePromoCodePrice: item?.result?.showOriginalPrice || false,
    }
    this.setState(
      {
        ajaxSpinnerActive: true,
        loadingHandleReservation: true,
        loadingHandleReservationError: undefined,
      },
      () => {
        axios
          .post(endpoint.ADD_RESERVATION(), data)
          .then((result) => result.data)
          .then((result) => {
            if (result.message) {
              console.debug(result.message)
            }
            if (result.booking) {
              this.saveGuidToSessionStorage(result)
              const parkingLink = this.getReserveLink(result.booking.guid, productId)
              window.location.href = parkingLink
            }
          })
          .catch((error) => {
            this.axiosErrorHandler(error, {
              ajaxSpinnerActive: false,
              loadingHandleReservation: false,
              loadingHandleReservationError: error,
            })
          })
      },
    )
  }

  saveGuidToSessionStorage(res) {
    sessionStorage.setItem("CPH:BOOKING_GUID", res.booking.guid)
  }

  getParkingStarter = () => {
    const highlightDates = this.getHighlightDates(this.state.adt, this.state.ddt)

    const CustomInput = forwardRef(({ value, onClick, mainLabel }, ref) => (
      <div onClick={onClick} ref={ref}>
        <label>{mainLabel}</label>
        {value.replace(" ", " kl. ")}
      </div>
    ))
    CustomInput.displayName = "CustomInput"

    const FromContainer = ({ className, children }) => {
      return (
        <CustomCalendarContainer className={className} label={this.props.block.fromLabel || "From"}>
          {children}
        </CustomCalendarContainer>
      )
    }

    const ToContainer = ({ className, children }) => {
      return (
        <CustomCalendarContainer className={className} label={this.props.block.toLabel || "Til"}>
          {children}
        </CustomCalendarContainer>
      )
    }

    const buttonColor = SelectionFactoryHelper.getFromSelectionFactory(this.props.block.parkingButtonColor)
    const buttonStyle = { "--btn-hover": this.props.block.parkingButtonHoverColor }
    const anchorLink = this.getSearchLink() + "#all-options"

    const stepHeaderTextKeys = this.state.parkingConfig?.textKeys?.stepHeader || {}

    const priceFormatter = (price, hideCurrency) =>
      `${new Intl.NumberFormat("da-DK", { style: "decimal", minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(price)}${
        hideCurrency ? "" : " DKK"
      }`

    return (
      <React.Fragment>
        <Spinner isActive={this.state.ajaxSpinnerActive} isTransparent={this.state.ajaxSpinnerTransparent} />
        <div className="dateselect" style={buttonStyle}>
          <div className="form__section form__section--split">
            <div className={`form__section__inner dateselect-from`}>
              <DatePicker
                popperClassName="datepicker-from"
                ref={(r) => (this.adtCalender = r)}
                selected={this.state.adt.toJSDate()}
                onChange={(date) => this.handleFromDateChange(date)}
                showTimeSelect
                dateFormat={this.state.language === "en" ? "dd.MM.yyyy h:mm aa" : "dd.MM.yyyy HH:mm"}
                timeFormat={this.state.language === "en" ? "h:mm aa" : "HH:mm"}
                minDate={this.state.today.toJSDate()}
                minTime={this.state.aMinTime.toJSDate()}
                maxTime={this.state.maxTime.toJSDate()}
                locale={this.state.language === "en" ? enGB : da}
                customInput={<CustomInput mainLabel={this.props.block.fromLabel || "Fra"} />}
                timeCaption={this.props.block.timeLabel || "Tidspunkt"}
                highlightDates={highlightDates}
                onCalendarOpen={this.addEventListeners}
                withPortal={isMobile ? true : false}
                // portalId={isMobile ? "root-portal" : undefined}
                portalId={"tp-parking"}
                calendarContainer={FromContainer}
                popperPlacement="bottom-start"
                popperModifiers={[
                  {
                    name: "flip",
                    options: {
                      fallbackPlacements: ["bottom-start"], // disables flip by setting the fallback to the same as the chosen placement
                    },
                  },
                ]}
              />
            </div>
          </div>
          <div className="form__section form__section--split">
            <div className={`form__section__inner dateselect-to`}>
              <DatePicker
                popperClassName="datepicker-to"
                ref={(r) => (this.ddtCalender = r)}
                selected={this.state.ddt ? this.state.ddt.toJSDate() : null}
                onChange={(date) => this.handleToDateChange(date)}
                showTimeSelect
                dateFormat={this.state.language === "en" ? "dd.MM.yyyy h:mm aa" : "dd.MM.yyyy HH:mm"}
                timeFormat={this.state.language === "en" ? "h:mm aa" : "HH:mm"}
                minDate={this.state.minDate.toJSDate()}
                minTime={this.state.dMinTime.toJSDate()}
                maxTime={this.state.maxTime.toJSDate()}
                locale={this.state.language === "en" ? enGB : da}
                customInput={<CustomInput mainLabel={this.props.block.toLabel || "Til"} />}
                timeCaption={this.props.block.timeLabel || "Tidspunkt"}
                highlightDates={highlightDates}
                withPortal={isMobile ? true : false}
                // portalId={isMobile ? "root-portal" : undefined}
                portalId={"tp-parking"}
                calendarContainer={ToContainer}
                popperPlacement="bottom-end"
                popperModifiers={[
                  {
                    name: "flip",
                    options: {
                      fallbackPlacements: ["bottom-end"], // disables flip by setting the fallback to the same as the chosen placement
                    },
                  },
                ]}
              />
            </div>
          </div>
          <div className="form__section form__section--split">
            <div className="form__section__inner">
              <div
                className={`button button--medium button--general no-shadow ${buttonColor ? buttonColor : ""}`}
                onClick={() => this.parkingSearchHandler()}
              >
                <span className="text">{this.props.block.searchButtonLabel || "Søg"}</span>
              </div>
            </div>
          </div>
        </div>
        {this.state.parkingHighlights ? (
          <div className="parking-result">
            <RefundGuarantee
              textKeys={config.get("textKeys.refundGuaranteeTravelPlanner") || {}}
              setDataToState={this.handleModalOpen}
              trackingFunction={this.handleRefundGuaranteeModalTracking}
              useNewDesign={config.get("textKeys.productPodium")?.useNewProductPodiumDesign ?? false}
            />
            <ParkingProductHightlight
              highlights={this.state.parkingHighlights}
              handleReservation={this.handleReservation}
              setParkingDetailModalState={this.handleModalOpen}
              content={this.state.parkingContent}
              userAccountDetails={this.state.userAccountDetails}
              priceFormatter={priceFormatter}
              arrivalDate={this.state.adt ? this.state.adt.toFormat("yyyy-MM-dd") : ""}
              departureDate={this.state.ddt ? this.state.ddt.toFormat("yyyy-MM-dd") : ""}
              flightId={this.state.flightInfo.FlightId}
              useNewDesign={config.get("textKeys.productPodium")?.useNewProductPodiumDesign ?? false}
              enableCarousel={false}
              uspLimit={config.get("textKeys.productPodium")?.productPodiumUspLimit ?? 3}
              handleCloseMapModal={this.handleCloseMapModal}
              handleOpenMapModal={this.handleOpenMapModal}
              globals={this.state.globals}
              deck={config.get("textKeys.productPodium")?.useNewProductPodiumDesign ? "deck deck--white" : "deck deck--white deck--padding-bottom"}
              wrapper={config.get("textKeys.productPodium")?.useNewProductPodiumDesign ? "" : "w--wider"}
            />
            {this.props.block.parkingPage ? (
              <div className="w--wider all-parking-options-wrapper">
                <a className="all-parking-options" onClick={() => this.handleAllParkingOptionsClick()} href={anchorLink}>
                  {stepHeaderTextKeys.seeAllParkingsText || "Se alle parkeringsmulighederne"}
                </a>
              </div>
            ) : (
              ""
            )}
          </div>
        ) : (
          ""
        )}
        {this.state.isParkingDetailsModalActive ? (
          <ParkingDetailsModal
            isActive={this.state.isParkingDetailsModalActive}
            allProducts={this.state.allProducts}
            item={this.state.parkingDetailsModalItem}
            handleReservation={this.handleReservation}
            handleParkingDetailsClose={this.handleParkingDetailsClose}
            handleParkingDetailsCleanup={this.handleParkingDetailsCleanup}
            handleSpecialProductClickFromDetails={this.handleSpecialProductClickFromDetails}
            handleDetailsCleanup={this.handleBuySpecialProductCleanup}
            durationDays={this.state.durationDays}
            setParkingDetailModalState={this.handleModalOpen}
            handleCloseMapModal={this.handleCloseMapModal}
            handleOpenMapModal={this.handleOpenMapModal}
            isParkingProductMapModalActive={this.state.isParkingProductMapModalActive}
            isParkingHighlightModalActive={this.state.isParkingHighlightModalActive}
            priceFormatter={priceFormatter}
            userAccountDetails={this.state.userAccountDetails}
            setLoginState={this.setLoginState}
            useNewDesign={config.get("textKeys.productPodium")?.useNewProductPodiumDesign ?? false}
          />
        ) : null}
        {this.state.isParkingProductMapModalActive ? (
          <ParkingShowMapModal
            item={this.state.parkingDetailsModalItem}
            handleCloseMapModal={this.handleCloseMapModal}
            handleOpenMapModal={this.handleOpenMapModal}
            content={this.state.parkingContent}
          />
        ) : null}
        {this.state.isParkingSpecialProductActive ? (
          <ParkingAcceptConditionsModal
            isActive={this.state.isParkingSpecialProductActive}
            item={this.state.parkingDetailsModalItem}
            handleReservation={this.handleReservation}
            handleSpecialProductDetailsClose={this.handleSpecialProductDetailsClose}
            handleSpecialProductDetailsCleanup={this.handleSpecialProductDetailsCleanup}
            durationDays={this.state.durationDays}
            setParkingDetailModalState={this.setParkingDetailModalState}
            priceFormatter={priceFormatter}
          />
        ) : null}
        {this.state.isParkingMemberProductActive ? (
          <ParkingBuyMemberProductModal
            isActive={this.state.isParkingMemberProductActive}
            item={this.state.parkingDetailsModalItem}
            handleReservation={this.handleReservation}
            handleBuyMemberProductModalClose={this.handleBuyMemberProductModalClose}
            handleDetailsCleanup={this.handleBuyMemberProductCleanup}
            isAmendment={true}
            durationDays={this.state.durationDays}
            setParkingDetailModalState={this.setParkingDetailModalState}
            setLoginState={this.setLoginState}
            userAccountDetails={this.state.userAccountDetails}
            priceFormatter={priceFormatter}
          />
        ) : null}
      </React.Fragment>
    )
  }

  handleAccordionClick = (e) => {
    this.showHideContent(e, ".contentWrapper")
    this.setState({ sectionOpen: !this.state.sectionOpen })
    this.handleAccordionTracking()
  }

  handleAccordionTracking = () => {
    this.setState({ accordionOpen: !this.state.accordionOpen }, () => {
      if (this.state.accordionOpen) {
        trackTravelPlannerInteraction(this.props.tabToggle, "fold_open", { fold_title: this.props.block.heading })
      } else {
        trackTravelPlannerInteraction(this.props.tabToggle, "fold_close", { fold_title: this.props.block.heading })
      }
    })
  }

  render() {
    const buttonSvg =
      this.state.travelFormBlock && this.state.travelFormBlock.buttonIcon
        ? SelectionFactoryHelper.getFromSelectionFactory(this.state.travelFormBlock.buttonIcon)
        : SelectionFactoryHelper.getFromSelectionFactory(this.props.block.buttonIcon)
    const buttonColor = SelectionFactoryHelper.getFromSelectionFactory(this.props.block.buttonColor)
    const theme = SelectionFactoryHelper.getFromSelectionFactory(this.props.block.backgroundColor)
    const hasContentBlocksBeforeText = this.props.block.contentAreaBeforeText?.length > 0
    const hasContentBlocks = this.props.block.contentArea?.length > 0
    let buttonLink = this.props.block.buttonLink
    if (this.props.block.linkToAirlineBool) buttonLink = this.state.airlinesPageLink + "/" + this.state.flightInfo.IataCode
    if (this.props.block.buttonAddParkingQueryString) {
      const ROUNDING = 30 * 60 * 1000 /*ms*/
      const dtLocale = dateHelper.luxonLocale(this.state.flightInfo.language)
      const zone = "Europe/Copenhagen"
      const estimatedPublicTime = DateTime.fromISO(this.state.flightInfo.EstimatedPublicTime).setLocale(dtLocale).setZone(zone)
      const flightInfoDate = estimatedPublicTime.minus({ minutes: this.props.checkInOpens }).minus({ minutes: 60 })
      const roundedDate = DateTime.fromMillis(Math.round(+flightInfoDate.toMillis() / ROUNDING) * ROUNDING)
        .setLocale(dtLocale)
        .setZone(zone)
      buttonLink += `?ad=${roundedDate.toFormat("yyyy-MM-dd")}&at=${roundedDate.toFormat("HH")}:00` // floor to the hour
    }

    const style = { "--itinerary-icon": `url(${this.props.block.itineraryIcon ? this.props.block.itineraryIcon : ""})` }

    let parkingStarter = ""
    if (this.state.showBookingStarter) {
      parkingStarter = this.getParkingStarter()
    }
    const parkingStarterSvg = SelectionFactoryHelper.getFromSelectionFactory(this.props.block.parkingStarterIcon)

    return (
      <div
        id={"arrival-at-airport"}
        style={this.props.block.itineraryIcon ? style : undefined}
        className={`departure-info__essentials__detailitems__detailitem foldable ${theme ? theme : ""}`}
      >
        <div className={"departure-info__essentials__detailitems__detailitem__header pointer"} onClick={(e) => this.handleAccordionClick(e)}>
          <h5>{this.props.block.heading}</h5>
          {this.props.block.subHeading ? <h6>{this.props.block.subHeading}</h6> : ""}
        </div>
        <div className={"contentWrapper show-hide"}>
          <div className="innerContentWrapper">
            {hasContentBlocksBeforeText ? this.renderContentBlocks(this.props.block.contentAreaBeforeText) : ""}
            {this.props.block.text || this.props.block.buttonText ? (
              <div className={"textbuttoncontainer"}>
                {this.props.block.text ? (
                  <span
                    className="rich-text"
                    dangerouslySetInnerHTML={{
                      __html:
                        this.state.travelFormBlock && this.state.travelFormBlock.travelFormText
                          ? this.state.travelFormBlock.travelFormText
                          : this.props.block.text,
                    }}
                  ></span>
                ) : (
                  ""
                )}
                {this.props.block.buttonText && this.props.block.buttonLink ? (
                  <div className="cta-button">
                    <a
                      className={`button button--small button--general button__floatbox rm-this-class rm-this-class-hide-default ${
                        buttonColor ? buttonColor : "casc-blue"
                      }`}
                      href={this.state.travelFormBlock && this.state.travelFormBlock.buttonLink ? this.state.travelFormBlock.buttonLink : buttonLink}
                      onClick={() =>
                        this.handleClickTracking(
                          this.state.travelFormBlock && this.state.travelFormBlock.buttonTracking
                            ? this.state.travelFormBlock.buttonTracking
                            : this.props.block.buttonTracking,
                        )
                      }
                    >
                      {buttonSvg !== "" ? <Svg iconName={buttonSvg} /> : ""}
                      <span className="text">
                        {this.state.travelFormBlock && this.state.travelFormBlock.buttonText
                          ? this.state.travelFormBlock.buttonText
                          : this.props.block.buttonText}
                      </span>
                    </a>
                  </div>
                ) : (
                  ""
                )}
              </div>
            ) : (
              ""
            )}
            {hasContentBlocks ? this.renderContentBlocks(this.props.block.contentArea) : ""}
            {this.state.showBookingStarter ? (
              <div className="itinerary-parking-starter">
                {this.props.block.parkingStarterLabel ? (
                  <div className="icon-text-container">
                    {parkingStarterSvg ? <Svg iconName={parkingStarterSvg} /> : ""}
                    <span className="text">{this.props.block.parkingStarterLabel}</span>
                  </div>
                ) : (
                  ""
                )}
                {parkingStarter}
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
        {this.state.showBookingStarter && this.state.genericModalActive ? (
          <GenericModal genericModalClose={this.genericModalClose} {...this.state} {...this.props} />
        ) : null}
        {this.state.showBookingStarter && this.state.refundGuaranteeModalOpen ? (
          <SimpleModal modalData={this.state.refundGuaranteeModalData} closeHandler={this.handleModalClose} />
        ) : (
          ""
        )}
      </div>
    )
  }
}

class CustomCalendarContainer extends Component {
  render() {
    return (
      <CalendarContainer className={this.props.className}>
        <div className="react-datepicker__triangle"></div>
        <div className={"calendar-header"}>{this.props.label}</div>
        <div className="calendar-container" style={{ position: "relative", height: "100%" }}>
          {this.props.children}
        </div>
      </CalendarContainer>
    )
  }
}
